import { render, staticRenderFns } from "./WineClubPopup.vue?vue&type=template&id=96a15be2&scoped=true&"
import script from "./WineClubPopup.vue?vue&type=script&lang=js&"
export * from "./WineClubPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a15be2",
  null
  
)

export default component.exports